<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'User',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>